// public/icons/MicIcon.jsx
import React from 'react';

const MicIcon = ({ size = 50, color = '#1E1E1E', className = '', ...props }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 50 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        d="M31.25 12.5C31.25 9.04822 28.4518 6.25 25 6.25C21.5482 6.25 18.75 9.04822 18.75 12.5V22.9167C18.75 26.3684 21.5482 29.1667 25 29.1667C28.4518 29.1667 31.25 26.3684 31.25 22.9167V12.5Z"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.5837 22.917C39.5837 24.8321 39.2065 26.7285 38.4736 28.4978C37.7407 30.2671 36.6665 31.8748 35.3123 33.229C33.9581 34.5832 32.3505 35.6574 30.5811 36.3902C28.8118 37.1231 26.9154 37.5003 25.0003 37.5003M25.0003 37.5003C23.0852 37.5003 21.1889 37.1231 19.4195 36.3902C17.6502 35.6574 16.0425 34.5832 14.6884 33.229C13.3342 31.8748 12.26 30.2671 11.5271 28.4978C10.7942 26.7285 10.417 24.8321 10.417 22.917M25.0003 37.5003V43.7503"
        stroke={color}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MicIcon ;